// extracted by mini-css-extract-plugin
module.exports = {"tooltip-anchor":"Tooltip_tooltip-anchor__G4wAh","tooltip-root":"Tooltip_tooltip-root__wbYn6"};